import type { LucideIcon } from 'lucide-react'

import {
    AirVent,
    Bath,
    Building2,
    Car,
    ChefHat,
    Droplets,
    Flame,
    Flower2,
    Fence,
    House,
    Landmark,
    Laptop,
    Mountain,
    MountainSnow,
    PlugZap,
    Sailboat,
    Snowflake,
    Sparkles,
    Sun,
    SunMedium,
    Tag,
    TentTree,
    Tractor,
    TreePalm,
    Trees,
    Umbrella,
    Waves,
    Wine,
    Check
} from 'lucide-react'

/*
 * Icon keys stored in the categories.icon and amenities.icon columns.
 * Any key not listed here falls back to a neutral icon.
 */
const ICONS: Record<string, LucideIcon> = {
    air: AirVent,
    bath: Bath,
    building: Building2,
    car: Car,
    'chef-hat': ChefHat,
    check: Check,
    deck: Fence,
    flame: Flame,
    flower: Flower2,
    home: House,
    house: House,
    landmark: Landmark,
    laptop: Laptop,
    mountain: Mountain,
    'mountain-snow': MountainSnow,
    palm: TreePalm,
    plug: PlugZap,
    pool: Droplets,
    sailboat: Sailboat,
    snowflake: Snowflake,
    solar: SunMedium,
    sparkles: Sparkles,
    sun: Sun,
    tag: Tag,
    trees: Trees,
    umbrella: Umbrella,
    waves: Waves,
    wine: Wine
}

export const getIcon = (key: string | null | undefined, fallback: LucideIcon = Sparkles): LucideIcon =>
    (key && ICONS[key.trim().toLowerCase()]) || fallback

const TYPE_ICONS: Array<[RegExp, LucideIcon]> = [
    [/cabin|chalet|a-frame/i, TentTree],
    [/farm|ranch/i, Tractor],
    [/condo|apartment|loft|townhouse|townhome/i, Building2],
    [/cottage|bungalow/i, Flower2],
    [/house|home|estate/i, House]
]

export const getTypeIcon = (type: string): LucideIcon =>
    TYPE_ICONS.find(([pattern]) => pattern.test(type))?.[1] ?? House
